import * as React from 'react';
import assertions from 'lib/assertions';
import FormElement from 'components/FormElement';
import Button from 'components/Button';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import BoxHeader from 'components/BoxHeader';
import PhoneNumberMaskedInput from 'components/PhoneNumberMaskedInput';
import Input from 'components/Input';

// @ts-ignore
import { ConfirmableDeviceType } from 'entities/Device';

type Props = {
  onDone: (submittedAddress: string) => void;
  closable?: boolean;
  footer?: React.ReactNode;
  title?: string;
  subtext?: string;
  deviceType: ConfirmableDeviceType;
  disabled: boolean;
};

type State = {
  submittedAddress: string;
};

class LinkDeviceInputBox extends React.Component<Props, State> {
  state = {
    submittedAddress: '',
  };

  deviceString = () => {
    return this.props.deviceType === 'email' ? 'email address' : 'phone number';
  };

  submitAddress = () => {
    const { submittedAddress } = this.state;
    this.props.onDone(submittedAddress);
  };

  renderPhoneNumberFormElement = () => {
    return (
      <FormElement
        label={this.deviceString()}
        labelHidden
        validate={e => {
          assertions.number(e.raw, 'Invalid phone number.');
          assertions.completePhoneNumber(e.raw, 'Invalid phone number.');
        }}
        onValidChange={i => this.setState({ submittedAddress: i.raw })}
        onInvalidChange={() => this.setState({ submittedAddress: '' })}
        element={PhoneNumberMaskedInput}
        elementProps={{
          className: 'LinkDeviceInputBox-input',
          placeholder: '+1 (555) 555-5555',
          name: 'address',
        }}
      />
    );
  };

  renderEmailFormElement = () => {
    return (
      <FormElement
        label={this.deviceString()}
        labelHidden
        validate={e => {
          assertions.email(e.target.value, 'Invalid email address.');
        }}
        onValidChange={e => this.setState({ submittedAddress: e.target.value })}
        onInvalidChange={() => this.setState({ submittedAddress: '' })}
        element={Input}
        elementProps={{
          className: 'LinkDeviceInputBox-input',
          placeholder: 'Enter an email address',
          name: 'address',
        }}
      />
    );
  };

  render() {
    return (
      <div>
        <BoxHeader
          title={this.props.title || `Add your ${this.deviceString()}`}
          subtext={this.props.subtext || "You'll be sent a confirmation code."}
        />
        <BoxBody divided>
          {this.props.deviceType === 'email'
            ? this.renderEmailFormElement()
            : this.renderPhoneNumberFormElement()}
          <Button
            className="LinkDeviceInputBox-submit"
            disabled={this.props.disabled}
            type="submit"
            eventElementName="LinkDeviceInputBox-Submit"
            onClick={this.submitAddress}>
            Send code
          </Button>
        </BoxBody>
        {this.props.footer ? <BoxFooter>{this.props.footer}</BoxFooter> : null}
      </div>
    );
  }
}
export default LinkDeviceInputBox;
